import { render } from "./groupcontent.vue?vue&type=template&id=f436b3d2"
import script from "./groupcontent.vue?vue&type=script&lang=js"
export * from "./groupcontent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__